module.exports = __webpack_public_path__ + "img/user.d4df8bdd.png";